<div class="empty-widget-body iflx-widget-body AT_widget_empty">
    <div class="well no-background">
        <div class="emptyWidget">
            <i class="favoriteWidget iflx-widget-min-height fa fa-plus alignCenter"></i>
        </div>
    </div>
</div>

